import React from "react";
import { Chart } from "primereact/chart";
import { Card } from "primereact/card";
import "./page.css";

const Dashboard = () => {
	// 📈 Line chart: динамика доставок
	const lineData = {
		labels: ["Янв", "Фев", "Мар", "Апр", "Май", "Июн"],
		datasets: [
			{
				label: "Испания",
				data: [20, 25, 30, 28, 32, 35],
				borderColor: "#FD4A5C",
				backgroundColor: "#FD4A5C55",
				tension: 0.4,
				fill: true,
			},
			{
				label: "США",
				data: [30, 35, 40, 42, 38, 45],
				borderColor: "#333",
				backgroundColor: "#33333333",
				tension: 0.4,
				fill: true,
			},
			{
				label: "Китай",
				data: [40, 42, 45, 47, 50, 55],
				borderColor: "#999",
				backgroundColor: "#99999944",
				tension: 0.4,
				fill: true,
			},
		],
	};

	// 📊 Bar chart: общий объём
	const barData = {
		labels: ["Испания", "США", "Китай"],
		datasets: [
			{
				label: "Объём доставок (в тыс. ед.)",
				backgroundColor: ["#FD4A5C", "#333", "#999"],
				data: [170, 230, 280],
			},
		],
	};

	// 🍩 Donut chart: доли
	const donutData = {
		labels: ["Испания", "США", "Китай"],
		datasets: [
			{
				data: [170, 230, 280],
				backgroundColor: ["#FD4A5C", "#333", "#999"],
				hoverBackgroundColor: ["#FF6B7C", "#555", "#aaa"],
			},
		],
	};

	const baseOptions = {
		plugins: {
			legend: {
				labels: {
					color: "#000",
				},
			},
		},
		scales: {
			x: {
				ticks: { color: "#000" },
				grid: { color: "#eee" },
			},
			y: {
				ticks: { color: "#000" },
				grid: { color: "#eee" },
			},
		},
	};

	return (
		<div className="dashboard">
			<h2 className="dashboard-title">Дашборд доставок</h2>
			<div className="dashboard-grid">
				<Card title="📈 Динамика доставок">
					<Chart type="line" data={lineData} options={baseOptions} />
				</Card>

				<Card title="📊 Объём по странам">
					<Chart type="bar" data={barData} options={baseOptions} />
				</Card>

				<Card title="🍩 Доля каждой страны">
					<Chart type="doughnut" data={donutData} />
				</Card>
			</div>
		</div>
	);
};

export default Dashboard;
